import React from 'react';
import { BlockWrapper, defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import MenuList from './MenuList';
import TopMenu from './TopMenu';
import style from './block.module.scss';
import clsx from 'clsx';

const Inspector = React.lazy(() => import('./Inspector'));

const Block = ({ menu, menuTop, categories, settings, seeMore, isHome, homeUrl }) => {
    useInspectorControl(Inspector);

    return (
        <BlockWrapper.Header className={clsx(style.header, isHome && style.home)}>
            <TopMenu menu={menuTop} isHome={isHome} />

            <div className={style.block}>
                <MenuList
                    menu={menu}
                    categories={categories}
                    settings={settings}
                    seeMore={seeMore}
                    isHome={isHome}
                    homeUrl={homeUrl}
                />
            </div>
        </BlockWrapper.Header>
    );
};

export default defineBlock({
    Block,
    smartProps: {
        stepPages: smartProps.object.withDefault({}),
        seeMore: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Header',
    },
});
